import { Exception, HosGridObject, PC_YM_STATUS } from '../hosLog/types';
import { ELD_DRIVER_STATUS, exceptionTypeByExceptionStatus } from 'src/constants/ELDConstants';
import { PendingException } from 'src/common/types';
import { ALASKA_TIME_ZONE, getDateWithoutTimezone } from 'src/utils/dateUtils';
import { HosLog } from 'src/features/hosLogs/types';
import moment from 'moment';

export const normalizeHosGridObject = (hosGridObject: HosGridObject[]): HosGridObject[] => {
  return hosGridObject.map(item => {
    let pcymStatus: PC_YM_STATUS | undefined;
    if (item.status === ELD_DRIVER_STATUS.OFF_PC) {
      pcymStatus = PC_YM_STATUS.PC;
    } else if (item.status === ELD_DRIVER_STATUS.ON_YM) {
      pcymStatus = PC_YM_STATUS.YM;
    }
    return {
      ...item,
      time: item.time.replace('AKST', ALASKA_TIME_ZONE),
      pcymStatus,
    };
  });
};

export const pendingExceptionAdaper = (
  exception: Exception,
  employeeId: number,
  exceptionDate: string,
  exceptionTimestamp: string,
): PendingException => ({
  exceptionId: exception.exceptionId,
  employeeId,
  logDate: exceptionDate,
  exceptionTimestamp,
  exceptionType: exceptionTypeByExceptionStatus[exception.exceptionType],
  comment: exception.notes,
  location: exception.driverLocation,
});

export const getHighlightedDays = (hosLogs: HosLog[]): any => {
  const highlightedDaysArray: Date[] = [];
  const highlightedMonthsObj: any = {};
  hosLogs.forEach(item => {
    const { violationCount, certifiedStatus, date } = item;
    const isCurrentDate = moment.utc(date).isSame(moment.utc(), 'day');

    if (violationCount > 0 || (certifiedStatus === 0 && !isCurrentDate)) {
      // TODO - add pending edits
      // highlightedDays
      highlightedDaysArray.push(getDateWithoutTimezone(date));

      // highlightedMonths
      const year = getDateWithoutTimezone(date).getFullYear();
      const month = getDateWithoutTimezone(date).getMonth();
      if (Array.isArray(highlightedMonthsObj[year])) {
        highlightedMonthsObj[year] = [...highlightedMonthsObj[year], month];
      } else {
        highlightedMonthsObj[year] = [month];
      }
    }
  });
  Object.keys(highlightedMonthsObj).forEach(item => {
    highlightedMonthsObj[item] = Array.from(new Set(highlightedMonthsObj[item]));
  });
  return {
    highlightedDays: [{ 'react-datepicker-events-day': highlightedDaysArray }],
    highlightedMonths: highlightedMonthsObj,
  };
};
